module.exports = __webpack_public_path__ + "assets/ResultsPlayButton.231ec825.svg";